import { MutationTree } from 'vuex'
import { UserState } from '../types'
import setUserState from './setUserState'
import setShowNotificationMobile from './setShowNotificationMobile'
import setUserDisabledSoundNotifications from './setUserDisabledSoundNotifications'

const mutations: MutationTree<UserState> = {
  setUserState,
  setShowNotificationMobile,
  setUserDisabledSoundNotifications,
}

export default mutations
